import React, {useEffect, useState} from "react";

import axios, {formUrlEncodedHeaders} from "config/axiosConfig";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import {formatDate} from "../../util/helpers";
import {Pagination} from "../../util/Pagination";

export default function Detail() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [content, setContent] = useState({});
    const [sendSchedules, setSendSchedules] = useState([]);
    const [paginationDto, setPaginationDto] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const id = queryParams.get("id");
    const page = searchParams.get('page') || "1";

    const requestData = () => {
        if (id !== null && id !== "") {
            axios.get(`/admin/push/triggers/${id}`)
                .then((res) => {
                    setContent(res.data);
                });
        }
    }

    const requestSendSchedules = () => {
        if (id !== null && id !== "") {
            const params = {};
            params.page = page;
            axios.get(`/admin/push/triggers/${id}/send-schedules`, { params: params })
                .then((res) => {
                    setPaginationDto(res.data);
                    setSendSchedules(res.data.content);
                });
        }
    }

    const requestSave = () => {
        (async () => {
            const params = {
                title: content.title,
                content: content.content,
                behaviorType: content.behaviorType,
                link: content.link,
                triggerCount: content.triggerCount,
                delayHour: content.delayHour,
                enabled: content.enabled,
            }

            const config = {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            };

            try {
                let savedRes = await axios.post(`/admin/push/triggers`, params, formUrlEncodedHeaders);
                if (savedRes.status === 200) {
                    alert('저장 되었습니다.');
                    navigate(-1);
                }
            } catch (err) {
                console.error(err);
                alert('저장 중 오류가 발생했습니다.');
            }
        })();
    }

    const requestSendPushTest = () => {
        (async () => {
            if (!content.title?.trim()) {
                alert("제목을 입력해주세요.");
                return;
            }
            if (!content.content?.trim()) {
                alert("내용을 입력해주세요.");
                return;
            }

            const params = {
                messageType: 'MARKETING',
                title: content.title,
                content: content.content,
                link: content.link
            }

            let savedRes = await axios.post(`/admin/push/messages/send-test`, JSON.stringify(params));
            if (savedRes.status === 200) {
                alert('발송 되었습니다.');
            }
        })();
    }

    const displayTriggerType = (triggerType) => {
        switch (triggerType) {
            case "MEMBERSHIP_GUIDE_VIEW": return "멤버십 이용안내 진입";
            case "EMPLOYMENT_CONTRACT_VIEW": return "근로계약서 진입";
            case "CHANNEL_TALK_VIEW": return "채널톡 진입";
            case "SALARY_CALCULATOR_VIEW": return "급여 계산하기 진입";
            case "INSURANCE_CALCULATOR_VIEW": return "4대보험 계산하기 진입";
            default: return "";
        }
    }

    const displayStatus = (status) => {
        switch (status) {
            case "PENDING": return "발송전";
            case "SUCCESS": return "발송완료";
            case "CANCELLED": return "발송취소";
            case "FAILED": return "발송실패";
        }
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams, {replace: true});
    }

    useEffect(() => {
        requestData()
    }, []);

    useEffect(() => {
        requestSendSchedules()
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">푸시메시지 - 행동기반 설정 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">
                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-sub-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>푸시 타입</label>
                                            <div className="col-sm-10" style={{paddingTop: "6px"}}>
                                                광고성
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>제목</label>
                                            <div className="col-sm-10">
                                                <input type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setContent({...content, title: event.target.value});
                                                       }}
                                                       value={content.title ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginTop: "10px" }}>
                                            <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                내용
                                            </label>
                                            <div className="col-sm-10">
                                                <textarea
                                                    className="form-control"
                                                    rows={4}
                                                    onChange={event => {
                                                        setContent({ ...content, content: event.target.value });
                                                    }}
                                                    value={content.content ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>링크</label>
                                            <div className="col-sm-10">
                                                <input type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setContent({...content, link: event.target.value});
                                                       }}
                                                       value={content.link ?? ""}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">
                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-sub-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>트리거 유형</label>
                                            <div className="col-sm-10" style={{paddingTop: "6px"}}>
                                                {displayTriggerType(content.behaviorType)}
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>진입횟수</label>
                                            <div className="col-sm-10">
                                                <input type="text" style={{width: "100px", textAlign: "right"}}
                                                       className="form-control"
                                                       onChange={e => {
                                                           const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                           setContent({...content, triggerCount: onlyNums});
                                                       }}
                                                       value={content.triggerCount ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>딜레이 시간(h)</label>
                                            <div className="col-sm-10">
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <input type="text" style={{width: "100px", textAlign: "right"}}
                                                           className="form-control"
                                                           onChange={e => {
                                                               const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                               setContent({...content, delayHour: onlyNums});
                                                           }}
                                                           value={content.delayHour ?? ""}
                                                    />
                                                    <span style={{marginLeft: "8px", color: "darkgray"}}>(시간 단위 입력. 1일인 경우 24)</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>사용 여부</label>
                                            <div className="col-sm-10">
                                                <select id="input-visible"
                                                        className="form-control"
                                                        style={{width: '100px', marginRight: '10px'}}
                                                        onChange={e => {
                                                            setContent({...content, enabled: e.target.value});
                                                        }}
                                                        value={content.enabled ?? "false"}>
                                                    <option value="true">사용</option>
                                                    <option value="false">미사용</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="row">
                        <div className="col-sm-12 d-flex justify-content-between">
                            {/* 왼쪽 버튼 */}
                            <div style={{ marginLeft: "30px" }}>
                                <button
                                    type="button"
                                    className="btn btn-outline-dark"
                                    style={{ marginLeft: "10px" }}
                                    onClick={requestSendPushTest}>
                                    발송 테스트
                                </button>
                            </div>

                            {/* 오른쪽 버튼 */}
                            <div style={{ marginRight: "30px" }}>
                                <button type="button" className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                                    목록
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    style={{ marginLeft: "10px" }}
                                    onClick={requestSave}
                                >
                                    수정
                                </button>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: "20px", marginLeft: "30px", color: "black" }}>
                        <div>- <b>광고푸시 수신 허용</b>을 한 사용자에게만 발송됩니다.</div>
                        <div>- <b>BASIC 멤버십 회원</b>에게만 발송됩니다.</div>
                        <div>- 발송 테스트: 모트, 돈기부여, 원풍갈비, 싱글앤 싱글 사업장으로 지금 즉시 푸시를 전송합니다.</div>
                    </div>

                    <section className="content" style={{marginTop: '70px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px', marginLeft: '20px'}}>
                                            <p className="lead">발송 회원</p>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '0px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>회원ID</th>
                                                    <th>이메일</th>
                                                    <th>비고</th>
                                                    <th>상태</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    sendSchedules && sendSchedules.map(item => {
                                                        return (
                                                            <tr key={item.userId}>
                                                                <td>{item.userId}</td>
                                                                <td>{formatDate(item.sendAt)}</td>
                                                                <td>{item.reason}</td>
                                                                <td>{displayStatus(item.status)}</td>
                                                                <td>
                                                                    <Link to={`/page/user/member/detail?userId=${item.userId}`} target="_blank">
                                                                        <button type="button"
                                                                                className="btn btn-outline-primary btn-sm">
                                                                            보기
                                                                        </button>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    { paginationDto && <Pagination pager={paginationDto} setPage={setPage}/> }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}